import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BarChartData } from 'Molecules/InsightsChart/chartBuilder';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseProjectsStatusPayload } from '../payloads/projectsStatusPayload';
import { InsightChartFactory } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';
import intl from 'react-intl-universal';

export const buildProjectsStatusInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseProjectsStatusPayload(payload);
  const { aggregate, data } = parsedPayload.data.attributes;

  return (props) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.V_BAR)
      .setProps({
        chartData: data as BarChartData,
        onDrillDown: props.onDrillDown,
        xAxisFieldName: 'project_status',
        yAxisFieldNames: ['project_count'],
        legendNames: [intl.get('INSIGHT.LEGEND.PROJECT_COUNT')],
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
      trendData: {
        value: aggregate.total_projects.current ?? 0,
        trend: aggregate.total_projects.percentage_change ?? 0,
        trendIsPercent: true,
        description: props.name,
      },
    });
  };
};
